/* ==========================================================================
   FUEL grain picker controller.

   One listener on the document. No framework, no build step, no dependency.

   WHAT IT IS RESPONSIBLE FOR, and nothing else:
     1. When the grain radio changes, rewrite every [data-fuel-macro] number on
        the page from the JSON the server already rendered.
     2. Keep the hidden line item property in step, so the ORDER records which
        grain the customer chose. Without this the picker would be a display
        that lies at checkout.
     3. Fire `fuel:grain` so any other section can follow without knowing about
        this file.

   WHAT IT IS NOT RESPONSIBLE FOR: the selected state of the control itself.
   That is CSS reading :checked, so it is correct on first paint and correct
   with JavaScript disabled. If this file fails to load, the page still shows a
   working radio group and the millet figures the server rendered - which are
   the right default, because fuel.grain is millet on every bowl today.
   ========================================================================== */
(function () {
  'use strict';

  var DATA_ID = 'fuel-macros-data';

  function macros() {
    var el = document.getElementById(DATA_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      // A malformed blob must not take the Add to cart button down with it.
      return null;
    }
  }

  function apply(grain) {
    var data = macros();
    if (!data || !data.grains || !data.grains[grain]) return;
    var set = data.grains[grain];

    document.querySelectorAll('[data-fuel-macro]').forEach(function (node) {
      var key = node.getAttribute('data-fuel-macro');
      if (key === 'label') {
        node.textContent = set.label || '';
      } else if (Object.prototype.hasOwnProperty.call(set, key)) {
        // The unit lives in the markup, never in the number, so a figure can be
        // read as a figure by anything that scrapes this page.
        node.textContent = String(set[key]);
      }
    });

    document.querySelectorAll('[data-fuel-grain-note]').forEach(function (node) {
      node.hidden = node.getAttribute('data-fuel-grain-note') !== grain;
    });

    document.querySelectorAll('[data-fuel-grain-prop]').forEach(function (input) {
      input.value = set.label || grain;
    });

    document.dispatchEvent(new CustomEvent('fuel:grain', {
      detail: { grain: grain, macros: set }
    }));
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-fuel-grain-input]')) return;
    apply(input.value);
  });

  // Sync once on load. The browser restores a checked radio on a back-navigation
  // or a reload, and without this the numbers would show the server's default
  // while the control showed the restored choice.
  function init() {
    var checked = document.querySelector('[data-fuel-grain-input]:checked');
    if (checked) apply(checked.value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
